import { useAppDispatch, useAppSelector } from '@app/core/hooks/redux-hooks';
import { FormProvider, useForm } from 'react-hook-form';
import { Toggle, ToggleSize } from '../toggle/Toggle';
import styles from './discount-rate-override-toggles.module.scss';
import { formConfigBase } from '@app/shared/constants/form-config-base';
import { FC, useEffect } from 'react';
import { setShowOriginalDiscountRates } from '@app/core/store/ui-values-slice';
import { useLocale } from '@app/core/hooks/useLocale';

const EnableShowOriginalDiscountRates: FC = () => {
  const { l } = useLocale();
  const dispatch = useAppDispatch();

  const showOriginalDiscountRatesState = useAppSelector(
    (state) => state.uiValues.showOriginalDiscountRates
  );

  type HeaderFormModel = {
    showOriginalDiscountRates: boolean;
  };

  const formMethods = useForm<HeaderFormModel>({
    ...formConfigBase,
    defaultValues: { showOriginalDiscountRates: showOriginalDiscountRatesState },
  });

  const { reset } = formMethods;

  useEffect(() => {
    reset({ showOriginalDiscountRates: showOriginalDiscountRatesState });
  }, [reset, showOriginalDiscountRatesState]);

  const handleToggleChange = (checked: boolean) => {
    dispatch(setShowOriginalDiscountRates(checked));
  };

  return (
    <FormProvider {...formMethods}>
      <span>
        <Toggle
          name="showOriginalDiscountRates"
          label={l('_ShowOriginalDiscountValues')}
          toggleSize={ToggleSize.Medium}
          className={styles['discount-rate-override-toggle']}
          onChange={(e) => handleToggleChange(e.target.checked)}
          data-testid="show-original-discount-values-toggle"
        />
      </span>
    </FormProvider>
  );
};

export default EnableShowOriginalDiscountRates;
